import { type FC } from 'react';
import ActiveLightningIcon from '@assets/img/icons/lightning-active.svg?react';
import cn from 'classnames';
import { motion, transform, useAnimate } from 'framer-motion';

interface EnergyLightningAnimationProps {
  energy: number;
  className?: string;
  isAnimationStart: boolean;
}

const EnergyLightningAnimation: FC<EnergyLightningAnimationProps> = ({
  className,
  energy,
  isAnimationStart,
}) => {
  const [scope, animate] = useAnimate();
  const energyToRectFillPosition = transform([0, 1000], [120, 0]);

  const secondAnimation = async (): Promise<void> => {
    await animate(
      scope.current,
      { opacity: 1 },
      { ease: 'easeOut', duration: 0.1 },
    );
    await animate(
      scope.current,
      { opacity: 0 },
      { ease: 'easeOut', delay: 0.1, duration: 0.7 },
    );
  };

  return (
    <div className={cn('relative', className)}>
      <motion.div
        ref={scope}
        initial={{ opacity: 0 }}
        // animate={isAnimationStart ? { opacity: [null, 1, 0] } : undefined}
        // transition={{ delay: 1, duration: 4 }}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[183px] h-[213px] z-20"
      >
        <ActiveLightningIcon />
      </motion.div>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="109"
        height="139"
        viewBox="0 0 109 139"
        fill="none"
      >
        <path
          data-figma-bg-blur-radius="16"
          d="M85.9092 0C87.5573 0 88.498 1.88152 87.5092 3.19999L54.4 47.3459C53.4111 48.6644 54.3519 50.5459 56 50.5459H104.035C105.817 50.5459 106.709 52.7002 105.449 53.9601L27.2991 132.11C25.7612 133.648 23.2202 131.972 24.0279 129.953L44.5845 78.5611C45.11 77.2474 44.1425 75.8184 42.7276 75.8184H3.13577C1.70861 75.8184 0.740704 74.3665 1.28963 73.0491L30.1891 3.69225C31.1207 1.4564 33.3053 0 35.7275 0H85.9092Z"
          fill="white"
          fill-opacity="0.3"
        />
        <mask
          id="mask0_18963_3290"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="1"
          y="0"
          width="106"
          height="133"
        >
          <path
            d="M85.9092 0C87.5573 0 88.498 1.88152 87.5092 3.19999L54.4 47.3459C53.4111 48.6644 54.3519 50.5459 56 50.5459H104.035C105.817 50.5459 106.709 52.7002 105.449 53.9601L27.2991 132.11C25.7612 133.648 23.2202 131.972 24.0279 129.953L44.5845 78.5611C45.11 77.2474 44.1425 75.8184 42.7276 75.8184H3.13577C1.70861 75.8184 0.740704 74.3665 1.28963 73.0491L30.1891 3.69225C31.1207 1.4564 33.3053 0 35.7275 0H85.9092Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_18963_3290)">
          <motion.rect
            initial={{ y: energyToRectFillPosition(energy) }}
            animate={isAnimationStart ? { y: 0 } : undefined}
            transition={{
              ease: 'easeOut',
              duration: 1,
            }}
            onAnimationComplete={secondAnimation}
            x="-3"
            width="111"
            height="132"
            fill="url(#paint0_linear_18963_3290)"
          />
        </g>
        {/* <g filter="url(#filter0_f_18963_3542)">
          <path
            d="M127.911 28C132.776 28 135.588 33.4648 132.85 37.4092L132.715 37.5957L97.708 84.3643H148.179C153.437 84.3645 156.115 90.6203 152.598 94.4229L152.426 94.6025L64.2812 182.923C59.6716 187.542 52.0432 182.521 54.4619 176.461L76.7832 120.546H34.998C30.7184 120.546 27.8149 116.194 29.458 112.242L61.9277 34.1602L62.0791 33.8145C63.7068 30.2809 67.2479 28 71.1611 28H127.911Z"
            stroke="#FFD600"
            stroke-width="8"
          />
        </g> */}
        <defs>
          <linearGradient
            id="paint0_linear_18963_3290"
            x1="52.5"
            y1="0"
            x2="52.5"
            y2="132"
            gradientUnits="userSpaceOnUse"
          >
            <motion.stop
              initial={{ stopColor: '#FF3300' }}
              animate={isAnimationStart ? { stopColor: '#FFD600' } : undefined}
              transition={{
                ease: 'easeOut',
                duration: 1,
              }}
            />
            <motion.stop
              offset="1"
              initial={{ stopColor: '#FF3300' }}
              animate={isAnimationStart ? { stopColor: '#FF9E00' } : undefined}
              transition={{
                ease: 'easeOut',
                duration: 1,
              }}
            />
          </linearGradient>
          {/* <filter
            id="filter0_f_18963_3542"
            x="0.987305"
            y="0"
            width="181.211"
            height="212.753"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="12"
              result="effect1_foregroundBlur_18963_3542"
            />
          </filter> */}
        </defs>
      </svg>
    </div>
  );
};

export { EnergyLightningAnimation };
